import { Component, HostListener, Renderer2 } from '@angular/core';
import { Router } from '@angular/router';
import { formatDistanceToNow } from 'date-fns';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from 'src/app/_services/auth.service';
import { InsuranceLookupService } from 'src/app/_services/insuranceLookup.service';
import Swal from 'sweetalert2';

declare var $ : any
@Component({
  selector: 'app-site-header',
  templateUrl: './site-header.component.html',
  styleUrls: ['./site-header.component.css']
})

export class SiteHeaderComponent {

  currentRoute: string = '';
  mobileMenu: boolean = false;
  isActive: boolean = false;
  notificationActive : boolean = false;
  notifications : any = [];
  totalNotifications : number = 0;
  allNotification : boolean = false;


  constructor(private router: Router, private renderer: Renderer2 ,private authService : AuthService , private insuranceLookupService : InsuranceLookupService , private toastr: ToastrService) {
    this.currentRoute = this.router.url;
  }

  ngOnInit(){
  }


  toggleActive(active: boolean): void {
    this.isActive = active;
  }

  toggleNotoficationActive(active: boolean): void {
    this.notificationActive = active;
  }


  // Method to toggle mobile menu
  toggleMobileMenu() {
    this.mobileMenu = !this.mobileMenu;
    // Add or remove class from body based on mobileMenu state
    if (this.mobileMenu) {
      this.renderer.addClass(document.body, 'mobile_menu_open');
    } else {
      this.renderer.removeClass(document.body, 'mobile_menu_open');
    }
  }

  logoutClick(){
    $('#staticBackdrop').modal('hide')
    this.authService.logout()
  }

  // Listen for window resize events to close the mobile menu
  @HostListener('window:resize')
  onResize() {
    this.mobileMenu = false;
    this.renderer.removeClass(document.body, 'mobile_menu_open');
  }

  getNotification(limit : number | null) {
    this.insuranceLookupService.getNotification(limit
    ).subscribe({
      next: (data) => {
        this.totalNotifications = data.data.totalNotifications;
        this.notifications = data.data.notifications;
      },
      error: (error) => {
        this.toastr.error(error.status.message)
      }
    })
   }

   clearAllNotification() {
    this.insuranceLookupService.clearAllnotification(
    ).subscribe({
      next: (data) => {
        this.getNotification(4);
        this.allNotification = false
      },
      error: (error) => {
        this.toastr.error(error.status.message)
      }
    })
   }

   clearSingleNotification(id : string) {
    this.insuranceLookupService.clearSinglenotification(id
    ).subscribe({
      next: (data) => {
        this.getNotification(4);
        this.allNotification = false
      },
      error: (error) => {
        this.toastr.error(error.status.message)
      }
    })
   }
   timeAgo(timestamp: string): string {
    const date = new Date(timestamp);
    let result =  formatDistanceToNow(date, { addSuffix: true });
    result = result.replace('about ', '');
    return result
  }

  showAllNotification(){
    this.getNotification(null)
    this.allNotification = true;
  }

  showFewerNotification(){
    this.getNotification(4)
    this.allNotification = false;
  }

  notificationClick(notification : any){
    this.clearSingleNotification(notification._id)
    this.router.navigate([`/claim-tracker/view-record/${notification.patientId}`] , { queryParams: { section: notification.notificationType} })
  }
  
  logout() {
    Swal.fire({
      title: "Are You Sure You Want To Logout?",
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "OK",
      allowOutsideClick: false,
      allowEscapeKey: false,
    }).then((result) => {
      if (result.isConfirmed) {
        this.authService.logout()
      }
    });
  }


}
